// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".school-input__modal-wrapper[data-v-fed88bac]{min-height:400px}@media only screen and (min-width:960px){.school-input__modal-wrapper[data-v-fed88bac]{margin-top:-60px}.school-input__modal-wrapper[data-v-fed88bac] .v-input{margin-right:70px}}.school-input[data-v-fed88bac] .v-input__prepend-outer{margin-right:0!important;margin-top:8px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
